import { useState, useEffect } from 'react'
import Table from 'components/ui/Table/Table'
import PropTypes from 'prop-types'
import ColumnFilter from 'components/ui/Table/ColumnFilter'
import { AiOutlineCheck, AiOutlineClose, AiOutlineSmile, AiOutlineMeh, AiOutlineFrown } from 'react-icons/ai'

export default function ListTable({ items, handleClick, users }) {
  const [tableData, setTableData] = useState([])
  
  // ----------------------------------
  const currentdate = new Date()
  const datetime =
    String(currentdate.getFullYear()) +
    '-' +  
    String(currentdate.getMonth() + 1).padStart(2, '0') +
    '-' +
    String(currentdate.getDate()).padStart(2, '0')
  // ----------------------------------

  // Nombre de las columnas de las tablas, el 'accessor' es el nombre por el cual se enlazará la columna
  // con el campo de los registros que nos llegan. Es como la propiedad 'name' en un formulario:
  const tableColumns = [    
    {
      Header: ' ',
      accessor: 'PreventiveWeaving_Semafor',      
      Filter: ColumnFilter,      
      Cell: ({ value }) =>
        parseInt(value, 10) > 15 ? (
          <AiOutlineSmile
            color="green"
            // className="p-1 my-0 ml-4 bg-green-200 rounded-full 2xl:ml-6 "
            size={24}
          />
        ) : parseInt(value, 10) < 0 ? (
          <AiOutlineFrown            
            color="red"
            // className="p-1 my-0 ml-4 bg-red-200 rounded-full 2xl:ml-6"
            size={24}
          />
        ) : (
          <AiOutlineMeh            
            color="orange"
            // className="p-1 my-0 ml-4 bg-red-200 rounded-full 2xl:ml-6"
            size={24}
          />
        )
    },
    {
      Header: 'Dies Pdts',
      accessor: 'PreventiveWeaving_PendingDays',
      Filter: ColumnFilter,            
    },   
    {
      Header: 'Màquina',
      accessor: 'PreventiveWeaving_IdMaq',
      Filter: ColumnFilter
    },
    {
      Header: 'Equip',
      accessor: 'PreventiveWeaving_EquipName',
      Filter: ColumnFilter
    }, 
    {
      Header: 'Dia previst',
      accessor: 'PreventiveWeaving_NoticeDate',
      Filter: ColumnFilter      
    },    
    {
      Header: 'Nau',
      accessor: 'PreventiveWeaving_Shed',
      Filter: ColumnFilter
    },
    {
      Header: 'Nivell',
      accessor: 'PreventiveWeaving_Level',
      Filter: ColumnFilter
    },
    // {
    //   Header: 'Pàrquing',
    //   accessor: 'parking',
    //   Filter: ColumnFilter
    // },    
    {
      Header: 'Crític',
      accessor: 'PreventiveWeaving_IsCritical',
      Filter: ColumnFilter,
      Cell: ({ value }) =>
      value  ? (
        <AiOutlineCheck
          color="green"
          className="p-1 my-0 ml-4 bg-green-200 rounded-full 2xl:ml-6 "
          size={23}
        />
      ) : (
        <AiOutlineClose
          className="p-1 my-0 ml-4 bg-red-200 rounded-full 2xl:ml-6"
          color="#be0043"
          size={23}
        />
      )
    },
    // {
    //   Header: 'Responsable',
    //   accessor: 'userResponsableId',
    //   Filter: ColumnFilter
    // },
    {
      Header: 'Responsable',
      accessor: 'PreventiveWeaving_UserResponsableName',
      Filter: ColumnFilter
    },
    {
      Header: 'Freq.mesos',
      accessor: 'PreventiveWeaving_MonthFrequency',
      Filter: ColumnFilter
    },
    {
      Header: 'Freq',    // 'Estat i dies que falten',
      accessor: 'PreventiveWeaving_Frequency',
      Filter: ColumnFilter
    },    
    {
      Header: 'Registre',
      accessor: 'PreventiveWeaving_Record',
      Filter: ColumnFilter
    },    
    {
      Header: 'Descripció',
      accessor: 'PreventiveWeaving_Information',
      Filter: ColumnFilter
    },            
    {
      Header: 'Comentari',
      accessor: 'PreventiveWeaving_Comment',
      Filter: ColumnFilter
    }, 
    {
      Header: 'Edició',
      accessor: 'PreventiveWeaving_LastModificationDate',
      Filter: ColumnFilter
    },        
  ]

  // useEffect() para crear un nuevo objeto, a partir de cada registro que se quiera mostrar en la tabla, para que los nombres
  // de los campos se enlacen con los 'accessor' de las columnas de la tabla:
  useEffect(() => {
    if (items) {
      const itemsData = []
      items.forEach((item) => {

        // Calcular dias pendientes entre fecha preventivo y próxima generación (se calcula en función de la fecha sistema):
        const data1 = new Date(item.NoticeDate)
        const data2 = new Date(datetime)

        // passem de milisegons a dies (milisegons -> segons -> minuts -> hores -> dies)
        // const diff = (fecha2-fecha1)/(1000*60*60*24) 
        // toFixed(n) para mostrar n decimales
        const diff = ((data1-data2)/(86400000) ).toFixed(0)

        itemsData.push({          
          Id:                                     item.Id,
          PreventiveWeaving_Comment:              item.Comment,
          PreventiveWeaving_IsCritical:           item.IsCritical,
          PreventiveWeaving_Shed:                 item.Shed,
          PreventiveWeaving_Record:               item.Record,
          PreventiveWeaving_UserResponsableId:    item.UserResponsableId,
          PreventiveWeaving_UserResponsableName:  item.UserResponsableName,
          PreventiveWeaving_MonthFrequency:       item.MonthFrequency,
          PreventiveWeaving_Frequency:            item.Frequency,
          PreventiveWeaving_NoticeDate:           item.NoticeDate.slice(0,10),
          PreventiveWeaving_Information:          item.Description,
          PreventiveWeaving_Level:                item.Level,
          PreventiveWeaving_LastModificationDate: item.LastModificationDate && item.LastModificationDate.slice(0,10),
          PreventiveWeaving_IdMaq:                item.MachineId ? item.MachineId : item.EquipmentId,      
          PreventiveWeaving_EquipName:            item.MachineId ? item.MachineName : item.EquipmentName,    
          PreventiveWeaving_Semafor:              diff,
          PreventiveWeaving_PendingDays:          diff // Mostrara el resultado de calcular la diferencia entre dias
          // pendingDays: (diff < 0) ? // Mostrara el resultado de calcular la diferencia entre dias            
          //   diff
          // :
          //   diff  * (-1)
          // parking: item.Parking,
        })
      })
      setTableData(itemsData)
    }
  }, [items])

  return (
    <div className="overflow-x-auto">
      <div className="inline-block min-w-full align-middle you and me could run a bad romance">
        <div className="overflow-hidden border-b border-gray-200 shadow sm:rounded">
          {tableData.length > 0 && (
            <Table
              tableData={tableData}
              tableColumns={tableColumns}
              handleClick={handleClick}
            />
          )}
        </div>
      </div>
    </div>
  )
}

ListTable.propTypes = {
  items: PropTypes.array.isRequired,
  handleClick: PropTypes.func.isRequired,
  users: PropTypes.array,
  value: PropTypes.any
}